import { Field, useFormikContext } from "formik";
import React, { FC } from "react";
import { YEARLY_OPTION } from "../../../../constants/notification-key";
import { useLocale } from "../../../../contexts/localeContext";
import { TranslationKeys } from "../../../../contexts/TranslationKeys";
import { MultiSelectOption } from "../../../../models/MultiSelectOption";
import { getMonthsOfTheYear, getRecurrenceOptionss, getDaysOfTheWeek } from "../../../../utilities/DateUtils";
import { validateRecur, validateYearlyDay, validateYearlyOption } from "../../../../utilities/Validation";
import Label from "../../../label/label";
import SettingSelectField from "../../../settingFields/SettingSelectField";


const Yearly: FC = () => {
    const { values, setFieldValue } = useFormikContext<any>();
    const { translate } = useLocale();
    const yearlyOptions: MultiSelectOption[] = [
        { value: YEARLY_OPTION.ON, label: translate.byKey(TranslationKeys.on) },
        { value: YEARLY_OPTION.ON_THE, label: translate.byKey(TranslationKeys.onThe) }
    ]

    const onYearlyOptionsChanged = (option: MultiSelectOption) => {
        setFieldValue("yearlyOption", option.value)
    }

    return <div className="flex flex-col space-y-2">
        <div className="flex flex-row space-x-3">
            <span>{translate.byKey(TranslationKeys.recurEvery)}</span>
            <Field
                name="occurrences"
                valueName="occurrences"
                type="text"
                validate={(value) => validateRecur(value, translate)}
                className={`p-1 text-sm w-16 h-6 bg-gray-input overflow-hidden ml-1`} />
            <span>{translate.byKey(TranslationKeys.yearYears)}</span>
        </div>
        <div className="flex flex-row space-x-2">
            <div className="flex flex-col space-y-2">
                {yearlyOptions.map((option) => (
                    <div
                        key={option.value}
                        className="flex items-center text-sm font-medium ">
                        <Field
                            id={`radio-${option.value}`}
                            type="radio"
                            name="yearlyOption"
                            value={option.value}
                            validate={(value) => validateYearlyOption(value, translate)}
                            onChange={(_: any) => onYearlyOptionsChanged(option)} />
                        <Label htmlFor={`radio-${option.value}`} className="pl-1 text-sm">{option.label}</Label>
                    </div>
                ))}
            </div>
            <div className="flex flex-col" >
                <div className="flex flex-row space-x-3">
                    <SettingSelectField
                        accessor="monthOfTheYear"
                        className={`w-32 h-6 pl-1 ${values.yearlyOption !== YEARLY_OPTION.ON ? 'text-gray-500 cursor-not-allowed' : ''}`}
                        width="w-32"
                        required={values.yearlyOption === YEARLY_OPTION.ON}
                        disabled={values.yearlyOption !== YEARLY_OPTION.ON}
                        options={getMonthsOfTheYear(translate)} />
                    <Field
                        name="dayOfMonth"
                        valueName="dayOfMonth"
                        type="text"
                        validate={(value) => values.yearlyOption === YEARLY_OPTION.ON && validateYearlyDay(value, translate, values.yearlyOption)}
                        disabled={values.yearlyOption !== YEARLY_OPTION.ON}
                        className={`pl-1 text-sm w-16 h-7 bg-gray-input overflow-hidden ${values.yearlyOption !== YEARLY_OPTION.ON ? 'text-gray-500 cursor-not-allowed' : ''}`} />
                </div>
                <div className="flex flex-row space-x-3">
                    <SettingSelectField
                        accessor="occurrence"
                        className={`w-32 pl-1 ${values.yearlyOption !== YEARLY_OPTION.ON_THE ? 'text-gray-500 cursor-not-allowed' : ''}`}
                        width="w-32"
                        required={values.yearlyOption === YEARLY_OPTION.ON_THE}
                        disabled={values.yearlyOption !== YEARLY_OPTION.ON_THE}
                        options={getRecurrenceOptionss(translate)} />
                    <SettingSelectField
                        accessor="daysOfTheWeek"
                        className={`w-32 pl-1 ${values.yearlyOption !== YEARLY_OPTION.ON_THE ? 'text-gray-500 cursor-not-allowed' : ''}`}
                        width="w-32"
                        required={values.yearlyOption === YEARLY_OPTION.ON_THE}
                        disabled={values.yearlyOption !== YEARLY_OPTION.ON_THE}
                        options={getDaysOfTheWeek(translate)} />
                    <span >{translate.byKey(TranslationKeys.of)}</span>
                    <SettingSelectField
                        accessor="monthOfTheYear"
                        className={`w-32 h-6 pl-1 ${values.yearlyOption !== YEARLY_OPTION.ON_THE ? 'text-gray-500 cursor-not-allowed' : ''}`}
                        width="w-32"
                        newPageSize={5}
                        required={values.yearlyOption === YEARLY_OPTION.ON_THE}
                        disabled={values.yearlyOption !== YEARLY_OPTION.ON_THE}
                        options={getMonthsOfTheYear(translate)} />
                </div>
            </div>
        </div>
    </div>
}

export default Yearly;